import React, { useState, forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import './desktop-new-launch-brands-style.scss';

import { Loading } from '@atoms';
import ProductListTitle from '@src/componentsNew/ProductListTitle/ProductListTitle';
import Carousel from '@src/componentsNew/Carousel/Carousel';

import { UI_COMPONENT } from '@queries';
import { uiComponentVariables } from '@src/core/config';
import { uiComponent } from '@src/queries/__generated__/uiComponent';

import { goToUrl } from '@src/utils/urlCheck';

const slidesToShow = 4; // 한 화면에 보여질 슬라이드 개수

const DesktopNewLaunchBrands = forwardRef<HTMLDivElement>((_, ref) => {
  const history = useHistory();
  const [newLaunchBrands, setNewLaunchBrands] = useState([]);

  const { data, loading } = useQuery<uiComponent>(UI_COMPONENT, {
    variables: uiComponentVariables.newLaunchWeb,
    onCompleted: (data) => {
      const newLaunchBrandsData = data?.uicomponent?.items;

      if (newLaunchBrandsData?.length) {
        const activeNewLaunchBrandsData = newLaunchBrandsData.filter((newLaunchBrand) => newLaunchBrand.isActive);
        setNewLaunchBrands(activeNewLaunchBrandsData);
      }
    },
  });

  if (loading) {
    return <Loading />;
  }

  return newLaunchBrands?.length ? (
    <div className="desktop-new-launch-brands-wrapper" ref={ref}>
      <ProductListTitle title={'New Launched Brands'} typoVariant="h6" typoComponent="h6" />

      <Carousel
        customSetting={{
          dots: false,
          infinite: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 4000,
          slidesToShow: Math.min(slidesToShow, newLaunchBrands.length),
          slidesToScroll: 1,
          cssEase: 'linear',
        }}
      >
        {newLaunchBrands.map((newLaunchItem) => (
          <div className="image-wrapper" key={newLaunchItem.id}>
            <img
              src={newLaunchItem.imageWebUrl}
              onClick={() => goToUrl(history, newLaunchItem.link)}
              alt="new-launch-brand-image"
            />
          </div>
        ))}
      </Carousel>
    </div>
  ) : null;
});

export default DesktopNewLaunchBrands;
